import React from "react";
import { useTranslation } from "react-i18next";
import { CredentialPicker } from '../../../FlowConfigurationInputs/CredentialPicker/CredentialPicker';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import FieldLabel from "../../../FlowConfigurationInputs/FieldLabel/FieldLabel";
import { TrendingUpTwoTone } from "@material-ui/icons";

/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Returns     Component
 * @Author      Kerem Karadeniz
 */
export default function Connect({ action, variables, setOpenVariable }) {
  const { t } = useTranslation();
  const label = "CONTENT.CONFIGURATION-FORM.EWS.";
  let examplePath = "http://<";
  let examplePathUrl = "exhange server full fqdn>"
  let examplePathExt = "/PowerShell/";
  return (
    <div>
      <div className="form-element">
        {t(label + "PATH")}
        <TextInput
          action={action}
          inputName="url"
          variables={variables}
          setOpenVariable={setOpenVariable}
          isRequired
        />
        <small>{examplePath}{examplePathUrl}{examplePathExt}</small>
      </div>

      <div className="form-element">
        <FieldLabel name={t(label + 'USERNAME')} is_required />
        <CredentialPicker action={action} inputName="userName" variables={variables}
          setOpenVariable={setOpenVariable} isRequired hideRequired={true} />
      </div>
      <div className="form-element">
        <FieldLabel name={t(label + 'PASSWORD')} is_required />
        <CredentialPicker action={action} inputName="password" variables={variables}
          setOpenVariable={setOpenVariable} isRequired isPassword={true} hideRequired={true} />
      </div>

      {/* <div className="form-element">
        {t(label + "USERNAME")}
        <TextInput
          action={action}
          inputName="userName"
          variables={variables}
          setOpenVariable={setOpenVariable}
          isRequired
        />
      </div>

      <div className="form-element">
        {t(label + "PASSWORD")}
        <TextInput
          action={action}
          inputName="password"
          variables={variables}
          setOpenVariable={setOpenVariable}
          isRequired
        />
      </div> */}
    </div>
  );
}
